module.exports = __webpack_public_path__ + "static/menu-retail-6a036cf5331eefa07224e06eadb4b459.png";